import i18next from 'i18next';
import React, {Component, PropTypes} from 'react';
import classNames from 'classnames';
import {autobind} from 'core-decorators';

export default class Input extends Component {
    static propTypes = {
        query: PropTypes.string.isRequired,
        focus: PropTypes.bool.isRequired,
        setFocus: PropTypes.func.isRequired,
        setQuery: PropTypes.func.isRequired,
        onKeyDown: PropTypes.func.isRequired,
    };

    shouldComponentUpdate(nextProps) {
        return nextProps.query !== this.props.query
            || nextProps.focus !== this.props.focus
            || nextProps.setFocus !== this.props.setFocus
            || nextProps.setQuery !== this.props.setQuery
            || nextProps.onKeyDown !== this.props.onKeyDown;
    }

    @autobind
    setInputRef(ref) {
        this.input = ref;
    }

    @autobind
    focusInput() {
        this.input.focus();
    }

    @autobind
    handleInputFocus() {
        this.props.setFocus(true);
    }

    @autobind
    handleInputBlur() {
        setTimeout(this.props.setFocus, 200, false);
    }

    @autobind
    handleInputChange(event) {
        this.props.setQuery(event.target.value);
    }

    render() {
        const {query, onKeyDown} = this.props;

        return (
            <div
                className={classNames('cielo24-vwrap-input', {'cielo24-vwrap-focus': this.props.focus})}
                onClick={this.focusInput}
            >
                <i className='cielo24-vwrap-icon cielo24-vwrap-icon-search' aria-hidden={true} />
                <input
                    type='search'
                    placeholder={i18next.t('Search the video')}
                    aria-label={i18next.t('Search the video')}
                    ref={this.setInputRef}
                    value={query}
                    onFocus={this.handleInputFocus}
                    onBlur={this.handleInputBlur}
                    onChange={this.handleInputChange}
                    onKeyDown={onKeyDown}
                />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./scripts/components/search/input.js